import { render, staticRenderFns } from "./pbi-market-diagnosis-fiat-dealer-group.page.vue?vue&type=template&id=4915260a"
import script from "./pbi-market-diagnosis-fiat-dealer-group.page.vue?vue&type=script&lang=ts"
export * from "./pbi-market-diagnosis-fiat-dealer-group.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports